// Scroll suave hasta un elemento + sacudida "te falta completar esto"
// (modo Video con influencer, ADR-552/553). Lo usan el pill flotante de
// desktop (PresetDetailSheet) y el Generar sticky de mobile (ConfigurePanel).
//
// La sacudida arranca recién cuando el scroll TERMINÓ: en vez de un delay
// fijo (el scroll suave dura distinto según la distancia), se pollea la
// posición del elemento por frame y se dispara cuando queda estable 3
// frames seguidos (o al timeout de seguridad de 1.5s). Si el elemento ya
// estaba a la vista, eso resuelve en ~50ms y la sacudida es casi inmediata.

// rAF activo por target: un click rápido cancela el loop anterior del mismo
// elemento. Sin esto, dos loops concurrentes se pisan el remove/add de la
// clase y cortan la sacudida a la mitad (o la duplican).
const activeLoops = new Map<string, number>();

export function scrollToAndShake(targetId: string): void {
  const el = document.getElementById(targetId);
  if (!el) return;

  const prev = activeLoops.get(targetId);
  if (prev !== undefined) cancelAnimationFrame(prev);

  el.scrollIntoView({ behavior: 'smooth', block: 'center' });

  const start = performance.now();
  let lastTop: number | null = null;
  let stableFrames = 0;

  const tick = () => {
    const top = el.getBoundingClientRect().top;
    if (lastTop !== null && Math.abs(top - lastTop) < 0.5) {
      stableFrames += 1;
    } else {
      stableFrames = 0;
    }
    lastTop = top;

    if (stableFrames >= 3 || performance.now() - start > 1500) {
      activeLoops.delete(targetId);
      // Reflow de por medio para re-disparar la animación en clicks repetidos.
      el.classList.remove('animate-shake-strong');
      void el.offsetWidth;
      el.classList.add('animate-shake-strong');
      window.setTimeout(() => el.classList.remove('animate-shake-strong'), 700);
      return;
    }
    activeLoops.set(targetId, requestAnimationFrame(tick));
  };
  activeLoops.set(targetId, requestAnimationFrame(tick));
}
